import { ExpandableCard, IconButton, SearchField, SelectedItemsProvider, useSelectedItems } from "../components";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";
import { StandardTests, StandardTestsTable } from "./components/StandardTests";
import { TestListView } from "@/api/williams/tests";
import { useSearchParams } from "react-router-dom";
import { printCertificate } from "@/api/williams/report";

export function StandardTestsList() {
  return (
    <SelectedItemsProvider>
      <StandardTestsContent />
    </SelectedItemsProvider>
  );
}

export function StandardTestsContent() {
  const [searchParams] = useSearchParams();
  const searchString = searchParams.get("search") ?? undefined;

  const selected = useSelectedItems<TestListView>();

  function handleDownloadPdf() {
    printCertificate(selected.items.map((x) => x.id));
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h3>Standard Tests</h3>
        <div className="d-md-none">
          <IconButton
            icon={faFilePdf}
            title="Download PDF"
            disabled={selected.items.length === 0}
            onClick={handleDownloadPdf}
          />
        </div>
      </div>
      <div className="d-flex flex-column-reverse flex-md-row justify-content-between mb-3">
        <SearchField />
        <div className="d-none d-md-block">
          <IconButton
            icon={faFilePdf}
            title="Download PDF"
            disabled={selected.items.length === 0}
            onClick={handleDownloadPdf}
          />
        </div>
      </div>

      {selected.items.length > 0 && (
        <div className="mb-2">
          <ExpandableCard caption={`Selected Tests (${selected.items.length})`}>
            <StandardTestsTable data={selected.items} search={searchString} />
          </ExpandableCard>
        </div>
      )}

      <StandardTests filters={{ searchString }} expanded={true} allowExpand={false} />
    </>
  );
}
